import fetch from '@/plugin/axios'

export function getOrganizations (data) {
  return fetch({
    url: '/api/common/admin/organization/page',
    method: 'Post',
    data
  })
}

export function saveOrganization (data) {
  return fetch({
    url: '/api/common/admin/organization/save',
    method: 'Post',
    data
  })
}

export function updateOrganization (data) {
  return fetch({
    url: '/api/common/admin/organization/update',
    method: 'Post',
    data
  })
}

export function getOrganizationSettings (data) {
  return fetch({
    url: '/api/common/admin/organization/settings',
    method: 'Post',
    data
  })
}

export function updateOrganizationSettings (data) {
  return fetch({
    url: '/api/common/admin/organization/update-settings',
    method: 'Post',
    data
  })
}

export function getOrganizationMembers (data) {
  return fetch({
    url: '/api/common/admin/organization/members',
    method: 'Post',
    data
  })
}

export function saveOrganizationMember (data) {
  return fetch({
    url: '/api/common/admin/organization/member-save',
    method: 'Post',
    data
  })
}

export function removeOrganizationMember (data) {
  return fetch({
    url: '/api/common/admin/organization/member-remove',
    method: 'Post',
    data
  })
}

export function getOrganizationInvitations (data) {
  return fetch({
    url: '/api/common/admin/organization/invitations',
    method: 'Post',
    data
  })
}

export function getOrganizationAudits (data) {
  return fetch({
    url: '/api/common/admin/organization/audits',
    method: 'Post',
    data
  })
}

// Internal organization to client organization service relations.
export function getServiceRelations (data) {
  return fetch({ url: '/api/common/admin/organization/service-relations/page', method: 'Post', data })
}

export function bindServiceRelation (data) {
  return fetch({ url: '/api/common/admin/organization/service-relations/bind', method: 'Post', data })
}

export function inviteServiceRelationAdmin (data) {
  return fetch({ url: '/api/common/admin/organization/service-relations/invite-admin', method: 'Post', data })
}

// Explicit names used by the service-relation management page and integrations.
export const getClientServiceRelations = getServiceRelations
export const bindClientServiceRelation = bindServiceRelation
export const inviteClientSpaceAdmin = inviteServiceRelationAdmin

export function getAiPointAccounts (data) {
  return fetch({
    url: '/api/common/admin/ai-point/accounts',
    method: 'Post',
    data
  })
}

export function getAiPointBuckets (data) {
  return fetch({
    url: '/api/common/admin/ai-point/buckets',
    method: 'Post',
    data
  })
}

export function getAiPointLedgers (data) {
  return fetch({
    url: '/api/common/admin/ai-point/ledgers',
    method: 'Post',
    data
  })
}

export function grantAiPoint (data) {
  return fetch({
    url: '/api/common/admin/ai-point/grant',
    method: 'Post',
    data
  })
}

export function getSubscriptionPlans (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/plans',
    method: 'Post',
    data
  })
}

export function saveSubscriptionPlan (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/plan-save',
    method: 'Post',
    data
  })
}

export function updateSubscriptionPlan (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/plan-update',
    method: 'Post',
    data
  })
}

export function getSubscriptions (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/subscriptions',
    method: 'Post',
    data
  })
}

export function cancelSubscription (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/subscription-cancel',
    method: 'Post',
    data
  })
}

export function manualActivateSubscription (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/manual-activate',
    method: 'Post',
    data
  })
}

export function getSubscriptionSeats (data) {
  return fetch({
    url: '/api/common/admin/ai-subscription/seats',
    method: 'Post',
    data
  })
}

export function getSubscriptionOrders (data) {
  return fetch({
    url: '/api/order/admin/ai-subscription-order/page',
    method: 'Post',
    data
  })
}
